import React, { useState } from "react";
import { Button, Input, message, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import Service from "../service";
import HrmsLogo from "../assets/images/HrmsLogo2.png"
// import ElsnerElevate from "assets/images/ElsnerElevate.svg";
// import icons8lock from "assets/images/icons8-lock.svg";
import {
  showAuthLoader,
  hideAuthLoader,
  userSignInSuccess,
} from "../appRedux/actions/Auth";
import IntlMessages from "../util/IntlMessages";
import moment from "moment";
import { setIsPasswordChange } from "../appRedux/actions/Common";
import { GoogleLogin } from "@react-oauth/google";

const SignIn = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Accessing a specific query parameter, e.g., 'redirect_uri'
  const redirect_uri = queryParams.get("redirect_uri");
  const dispatch = useDispatch();
  const history = useHistory();
  const { loader, alertMessage, showMessage } = useSelector(({ auth }) => auth);
  const Logo = localStorage.getItem("LogoURL");
  const isPassword = useSelector((Common) => Common)
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  console.log(isPassword.common.isPassword, 'isPasswordisPassword');

  const TOOL_PERMISSION_MAP = [
    { keywords: ["taskhub"], permissionKey: "isTaskHub" },
    { keywords: ["e-connect", "econnect", "connect"], permissionKey: "isEConnect" },
    { keywords: ["crm"], permissionKey: "isECRM" },
    { keywords: ["proposal"], permissionKey: "isProposal" },
    { keywords: ["vms", "visitor"], permissionKey: "isVMS" },
    { keywords: ["notetaker"], permissionKey: "isNoteTaker" },
    // { keywords: ["email"], permissionKey: "isEmailTool" },
    // { keywords: ["estimation"], permissionKey: "isEstimationTool" },
    // { keywords: ["hrms"], permissionKey: "isHRMS" },
  ];

  const getRequiredPermissionForUri = (uri) => {
    if (!uri) return null;
    const lowerUri = uri.toLowerCase();
    // The VMS host may not contain the word "vms"/"visitor" (e.g. localhost:PORT),
    // so match the configured VMS URL by host to gate the "Sign in with HRMS" flow.
    try {
      const vmsUrl = process.env.REACT_APP_VMS_SIGNIN;
      if (vmsUrl) {
        const vmsHost = new URL(vmsUrl).host.toLowerCase();
        if (vmsHost && lowerUri.includes(vmsHost)) return "isVMS";
      }
    } catch (e) { /* ignore malformed REACT_APP_VMS_SIGNIN */ }
    const match = TOOL_PERMISSION_MAP.find(({ keywords }) =>
      keywords.some((kw) => lowerUri.includes(kw))
    );
    return match?.permissionKey || null;
  };

  // const dis
  const SSORedirect = async (response) => {
    if (response?.data && response?.data?.data) {
      const userData = response.data.data;
      const requiredPermission = getRequiredPermissionForUri(redirect_uri);
      console.log("🚀 ~ SSORedirect ~ requiredPermission:", requiredPermission, redirect_uri, userData[requiredPermission])

      // If we recognize the tool and user lacks permission, block redirect
      if (requiredPermission && !userData[requiredPermission]) {
        message.error("You do not have permission to access this tool.");
        return;
      }
      window.open(
        `${redirect_uri}?token=${response.data.tokenForSSO.accessToken}`,
        "_self"
      );
    }
  };
  const onFinish = async (values) => {
    try {
      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.login,
        body: values,
      });
      dispatch(hideAuthLoader());

      if (response?.data && response?.data?.data) {
        if (redirect_uri) {
          SSORedirect(response);
          return;
        }
        const userData = response.data.data;
        console.log(userData.isPasswordChanged, 'userData');

        dispatch(setIsPasswordChange(userData.isPasswordChanged))

        localStorage.setItem("user_data", JSON.stringify(userData));
        localStorage.setItem(
          "accessToken",
          response.data.authToken.accessToken
        );
        localStorage.setItem(
          "ssoToken",
          response.data.tokenForSSO.accessToken
        );
        localStorage.setItem(
          "refreshToken",
          response.data.authToken.refreshToken
        );
        localStorage.setItem(
          "Last Login Time",
          moment().format("MMMM Do YYYY, h:mm:ss a")
        );
        localStorage.setItem(
          "resourceAccess",
          JSON.stringify(response.data.permissions)
        );
        history.push("/dashboard");

        dispatch(userSignInSuccess(userData));
        // if(userData?.emp_code){
        //   history.push('/employee-master')
        // }
        // else{
        //   history.push('/dashboard')
        // }
        // message.success(response.data.message);
      } else {
        const msg = response.data.message;
        const index = Service.add_message(msg);
        if (index === -1) {
          message.error(msg).then(() => {
            Service.remove_message(msg);
          });
        }
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  const 
  handleLogin = async (credentialResponse) => {
    // const decoded = jwtDecode(credentialResponse.credential);
    console.log("Decoded Google Data:", credentialResponse.credential,credentialResponse);
    console.log("Login Success", credentialResponse);
    // const decoded = jwtDecode(credentialResponse.credential);
    // console.log("Decoded ID Token:", decoded);
    const credentiaL= credentialResponse?.credential
    try {
      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.googleSSOLogin,
        body:JSON.stringify({ credential: credentiaL }),
      });
      dispatch(hideAuthLoader());
      console.log(response,'response');

      if (response?.status ==404){
return message.error(response?.data?.message)
      }
      if (response?.status ==403){
        return message.error(response?.data?.message)
              }
      if (response?.data && response?.data?.data) {
        console.log(response,'response');
        
        if (redirect_uri) {
          SSORedirect(response);
        }
        const userData = response.data.data;
        console.log(userData.isPasswordChanged, 'userData');

        dispatch(setIsPasswordChange(userData.isPasswordChanged))

        localStorage.setItem("user_data", JSON.stringify(userData));
        localStorage.setItem(
          "accessToken",
          response.data.authToken.accessToken
        );
        localStorage.setItem(
          "ssoToken",
          response.data.tokenForSSO.accessToken
        );
        localStorage.setItem(
          "refreshToken",
          response.data.authToken.refreshToken
        );
        localStorage.setItem(
          "Last Login Time",
          moment().format("MMMM Do YYYY, h:mm:ss a")
        );
        localStorage.setItem(
          "resourceAccess",
          JSON.stringify(response.data.permissions)
        );
        history.push("/dashboard");

        dispatch(userSignInSuccess(userData));
        // if(userData?.emp_code){
        //   history.push('/employee-master')
        // }
        // else{
        //   history.push('/dashboard')
        // }
        // message.success(response.data.message);
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
    // You can send this token to your backend to create a session
  };

  // const login = useGoogleLogin({
  //   onSuccess: (credentialResponse) => {
  //     handleLogin(credentialResponse);
  //   },
  //   onError: () => {
  //     console.log("Login Failed");
  //   },
  // });
  // const handleGoogleRedirect = () => {
  //   const clientId = "301739572344-ncfthalbcm1gmc5ap7jp593cni71cndc.apps.googleusercontent.com";
  //   const redirectUri = "http://localhost:3000/auth/callback"; // or your frontend redirect route
  //   const scope = "email profile openid";
  //   const responseType = "token";
  
  //   const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}`;
  
  //   window.location.href = authUrl;
  // };
  

  // const handleGoogleRedirect = () => {
  //   const clientId = "301739572344-ncfthalbcm1gmc5ap7jp593cni71cndc.apps.googleusercontent.com";
  //   const redirectUri = "http://localhost:3000/auth/callback";
  //   const scope = "openid email profile";
  //   const responseType = "code";
  
  //   const url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}&access_type=offline`;
  
  //   window.location.href = url;
  // };
  const handleGoogleLogin = () => {
    const popup = window.open(
      "http://localhost:8888/api/auth/google",
      "GoogleLogin",
      "width=500,height=600"
    );
  
    window.addEventListener("message", (event) => {
      if (event.origin !== "http://localhost:3000") return;
  console.log(event,'event');
  
      const { token } = event.data;
      if (token) {
        // const user = jwtDecode(token);
        console.log("✅ User:", token);
      }
  
      popup?.close();
    });
  };

  // Check authentication status when component mounts
  // useEffect(() => {
  //   const checkAuthStatus = async () => {
  //     try {
  //       const response = await axios.get('http://localhost:5000/api/auth/status');
  //       if (response.data.isAuthenticated) {
  //         setUser(response.data.user);
  //       }
  //     } catch (error) {
  //       console.error('Error checking auth status:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   checkAuthStatus();
  // }, []);
  return (
    <div className="gx-app-login-wrap account-login">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-login-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo account_logo">
                { Logo ? (
                  <img alt="example" src={ HrmsLogo } />
                ) : (
                  <img alt="example" src={ HrmsLogo } />
                ) }
              </div>

            </div>
            <div className="form-center-login">
              <div className="gx-app-logo-wid">
                <h2>
                  <IntlMessages id="app.userAuth.signIn" />
                </h2>
                <div className="gx-app-login-left-content">
                  <h6>Welcome to Elsner HRMS Portal</h6>
                </div>
              </div>
              <Form
                name="basic"
                onFinish={ onFinish }
                onFinishFailed={ onFinishFailed }
                className="gx-signin-form gx-form-row0"
              >
                <div className="form-label">
                  <span>
                    <label>Login Id</label>
                  </span>
                </div>
                <div className="form-content">
                  <Form.Item
                    rules={ [
                      {
                        required: true,
                        message: "Please enter your Login Id!",
                      },
                      {
                        type: "email",
                        message: "Please enter valid Login Id",
                      },
                    ] }
                    name="email"
                  >
                    <Input type="email" placeholder="Login Id" />
                  </Form.Item>
                  <span className="login-icon">
                    <i className="fas fa-envelope"></i>
                  </span>
                </div>
                <div className="form-label">
                  <span>
                    <label>Password</label>
                  </span>
                  {/* <span>Forgot Password?</span> */ }
                </div>
                <div className="form-content">
                  <Form.Item
                    name="password"
                    rules={ [
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ] }
                  >
                    <Input.Password placeholder="Password" />
                  </Form.Item>
                  <span className="login-icon lock">
                    <i className="fas fa-lock"></i>
                  </span>
                </div>
                <Form.Item>
                  <Button type="primary" className="gx-mb-0" htmlType="submit">
                    <IntlMessages id="app.userAuth.signIn" />
                  </Button>
                </Form.Item>
                <div>
                  <center>
                    Forgot your Login details?
                    <Link to="/forgot-password">
                      &nbsp;Get help logging in.
                    </Link>
                  </center>
                </div>
                <hr></hr>
                <div style={{maxWidth:"fit-content", margin:"auto" }}>
        <GoogleLogin
      onSuccess={(credentialResponse) => {
   
        handleLogin(credentialResponse)
      }}
      onError={() => {
        console.log("Login Failed");
      }}
    />

    {/* // */}
    {/* <div>
          <h2>Please log in</h2>
          <a href="http://localhost:5000/auth/google">
            <button>Login with Google</button>
          </a>
        </div> */}

      </div>
{/* <div style={{display:"flex",justifyContent:'center',alignItems:'center'}}>
<button
      onClick={() => login()}
      style={{
        padding: "10px 20px",
        backgroundColor: "transparent",
        color: "black",
        borderRadius: "4px",
        cursor: "pointer",
        borderStyle:'solid'
      }}
    >
      Sign in with Google
    </button>
</div> */}

   
      {/* <button onClick={handleGoogleLogin}>Login with Google (Redirect)</button> */}

              </Form>
            </div>
          </div>

          {/* { loader ? (
            <div className="gx-loader-view">
               <CircularProgress/>
              </div>
          ) : null } */}
          { showMessage ? message.error(alertMessage.toString()) : null }
        </div>
      </div>
    </div>
  );
};

export default SignIn;
